import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import config from "./config";
import "./css/stats.css";
import "./css/PressToTalk.css";
import "./css/buttons.css";
import "./css/tables.css";
import "./css/layout.css";
import Navigation from "./Navigation";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import "./css/DiscardMatchButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import TeamManagementModal from "./TeamManagementModal";

const API_URL =
  "https://lykns00a87.execute-api.us-east-2.amazonaws.com/default/football_app_data_crud";
const PressToTalk = () => {
  const [showStartMatchModal, setShowStartMatchModal] = useState(false);
  const devLog = (...args) => {
    if (config.IS_DEV) {
      console.log(...args);
    }
  };
  const [showHalfTimeReportButton, setShowHalfTimeReportButton] =
    useState(true);
  const [isTeamManagementVisible, setIsTeamManagementVisible] = useState(false);
  const Location = useLocation();
  const navigate = useNavigate();
  const [matchStarted, setMatchStarted] = useState(false);
  const {
    matchFolderName,
    myTeam = "",
    opposition = "",
    userId = "",
    selectedTeamId = "",
    matchId = "",
    matchFolder = "",
    matchDate = "",
    status = "",
    otherInfo = "",
    homeAway = "",
    initialTeamScores = { myTeamScore: 0, oppositionScore: 0 },
    formationPositions: initialFormationPositions = [],
    positionAssignments: initialPositionAssignments = {},
    formationCoordinates: initialFormationCoordinates = [],
    markerColor = "#FF4C4C",
    formation: initialFormation = "2-1-1",
    gkColor = "#4C6FFF",
    playerSelections: initialPlayerSelections = [],
    matchLength = "10",
    numberOfParts = "2",
    matchType = { name: "default", coordinates: [], positions: [] },
    selectedFormation = { name: "", coordinates: [], positions: [] },
  } = Location.state || {};
  const [formation, setFormation] = useState(initialFormation);
  const [formationCoordinates, setFormationCoordinates] = useState(
    initialFormationCoordinates
  );
  const [formationPositions, setFormationPositions] = useState(
    initialFormationPositions
  );
  const [positionAssignments, setPositionAssignments] = useState(
    initialPositionAssignments
  );
  const [playerSelections, setPlayerSelections] = useState(
    initialPlayerSelections
  );
  const players = playerSelections.length > 0 ? playerSelections : [];
  // const [showTeamManagementModal, setShowTeamManagementModal] = useState(false);
  const [actionLog, setActionLog] = useState([]);

  const logAction = (actionType, details) => {
    const timestamp = new Date().toISOString();
    const actionEntry = {
      actionType,
      details,
      timestamp,
    };
    setActionLog((prevLog) => [...prevLog, actionEntry]);
  };
  const [playerStats, setPlayerStats] = useState(
    players.map((player) => ({
      player_id: player.player_id,
      player_name: player.player_name || "Unnamed Player",
      goals: player.goals || 0,
      assists: player.assists || 0,
      shots_on_target: player.shots_on_target || 0,
      shots_off_target: player.shots_off_target || 0,
      defensive_actions: player.defensive_actions || 0,
      saves: player.saves || 0,
      position: player.position || "bench", // Include position if relevant
      status: player.status || "sub", // Include status if relevant
    }))
  );
  devLog("Initial playerSelections in state:", playerSelections);
  const prevPlayerStatsRef = useRef(playerStats);
  const prevFormationRef = useRef(formation);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [freeTierUsed, setFreeTierUsed] = useState(false);
  const [gamesLeft, setGamesLeft] = useState(0);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [maxRecordings, setMaxRecordings] = useState(0); // Dynamic max limit
  const [recordingsCount, setRecordingsCount] = useState(() => {
    // Retrieve initial value from local storage or default to 0
    const savedCount = localStorage.getItem("recordingsCount");
    return savedCount ? parseInt(savedCount, 10) : 0;
  });

  const [fetchedPlanLimits, setFetchedPlanLimits] = useState({});

  // This function computes the sum of goals from playerStats
  const calculateTotalPlayerGoals = () => {
    return playerStats.reduce((total, player) => total + player.goals, 0);
  };

  // Add this state at the top of your component (alongside other state variables)
  const [halfTimeProcessing, setHalfTimeProcessing] = useState(false);

  const handleHalfTimeReport = async () => {
    try {
      setHalfTimeProcessing(true);
      // Construct the file name and stats payload (same structure as finish match stats)
      const fileName = `${matchFolderName}/half-time-players-stats.json`;
      const statsData = {
        myTeam,
        opposition,
        teamScores,
        playerStats,
        actionLog,
        timestamp: new Date().toISOString(),
      };

      // Upload the half-time stats file to S3
      const uploadUrl = `https://${config.BucketName}.s3.${config.region}.amazonaws.com/${fileName}`;
      const uploadResponse = await fetch(uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(statsData),
      });

      if (!uploadResponse.ok) {
        console.error(
          "Failed to upload half-time stats:",
          uploadResponse.statusText
        );
        return;
      }
      devLog("Half-time stats uploaded successfully");

      // Build a JSON payload that mimics an S3 event trigger
      const s3EventPayload = {
        Records: [
          {
            s3: {
              bucket: {
                name: "football-app-audio-bucket",
              },
              object: {
                key: fileName,
              },
            },
          },
        ],
      };

      if (process.env.NODE_ENV !== "production") {
        devLog(
          "Payload sent to Lambda:",
          JSON.stringify(s3EventPayload, null, 2)
        );
      }

      // Invoke the Lambda via API Gateway
      const lambdaEndpoint =
        "https://1m4w3bdjp8.execute-api.us-east-2.amazonaws.com/prod/CoachesReport";
      const lambdaResponse = await axios.post(lambdaEndpoint, s3EventPayload);

      if (lambdaResponse.status === 200) {
        setShowHalfTimeReportButton(false);
        alert("Your report will arrive to your email within 5 minutes.");
      } else {
        console.error(
          "Lambda did not return a 200 status:",
          lambdaResponse.status
        );
      }
    } catch (error) {
      console.error("Error in handleHalfTimeReport:", error);
    } finally {
      setHalfTimeProcessing(false);
    }
  };

  // State for any manual (extra) adjustments to the team score
  const [extraGoals, setExtraGoals] = useState(0);

  useEffect(() => {
    setTeamScores((prev) => ({
      ...prev,
      myTeamScore: calculateTotalPlayerGoals() + extraGoals,
    }));
  }, [playerStats, extraGoals]);

  useEffect(() => {
    const fetchPlanLimitsFromLambda = async () => {
      try {
        const response = await axios.post(API_URL, {
          operationType: "get_plan_limits",
          data: {},
        });

        // The Lambda typically returns { statusCode: ..., body: "..." }.
        // So parse the body if it's a string:
        let planData = response.data.body;
        if (typeof planData === "string") {
          planData = JSON.parse(planData);
        }

        setFetchedPlanLimits(planData);
        devLog("Fetched plan limits from Lambda:", planData);
      } catch (error) {
        console.error("Error fetching plan limits from Lambda:", error);
      }
    };

    fetchPlanLimitsFromLambda();
  }, []);

  // useEffect(() => {
  //   checkMatchStarted();
  // }, []);

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      try {
        const response = await axios.post(API_URL, {
          operationType: "check_coach_subscription",
          data: { coach_id: userId },
        });

        const data =
          typeof response.data.body === "string"
            ? JSON.parse(response.data.body)
            : response.data.body;

        // Directly access the correct values
        setCurrentPlan(data.subscription_type || "unknown"); // Adjusted to match backend response
        setFreeTierUsed(data.free_tier_used || false); // Boolean already converted
        setGamesLeft(data.games_left_this_month || 0); // No need for parseInt as backend sends number
        setSubscriptionStatus(data.subscription_status || "unknown");
      } catch (err) {
        console.error("Error fetching subscription details:", err);
        setError("Failed to fetch subscription details.");
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionDetails();
  }, [userId]);

  useEffect(() => {
    if (fetchedPlanLimits && currentPlan) {
      // If the plan isn't found, default to 20 or whatever fallback you want
      const dynamicLimit = fetchedPlanLimits[currentPlan] ?? 20;
      setMaxRecordings(dynamicLimit);
    }
  }, [currentPlan, fetchedPlanLimits]);

  // Save recordingsCount to local storage whenever it changes
  useEffect(() => {
    localStorage.setItem("recordingsCount", recordingsCount);
  }, [recordingsCount]);

  useEffect(() => {
    if (prevFormationRef.current !== formation) {
      // Log the formation change
      const logEntry = {
        timestamp: new Date().toISOString(),
        actionType: "formation_change",
        details: {
          previousFormation: prevFormationRef.current,
          newFormation: formation,
        },
      };
      setActionLog((prevLog) => [...prevLog, logEntry]);

      // Update the ref with the new formation
      prevFormationRef.current = formation;
    }
  }, [formation]);

  useEffect(() => {
    const prevPlayerStats = prevPlayerStatsRef.current;
    const currentPlayerStats = playerStats;

    devLog("useEffect triggered due to playerStats change");

    // Create a map of previous player stats for quick lookup
    const prevStatsMap = new Map(
      prevPlayerStats.map((player) => [player.player_id, player])
    );

    currentPlayerStats.forEach((player) => {
      const prevPlayer = prevStatsMap.get(player.player_id);

      if (prevPlayer) {
        const statsToCheck = [
          "goals",
          "assists",
          "shots_on_target",
          "shots_off_target",
          "defensive_actions",
          "saves",
        ];

        statsToCheck.forEach((statKey) => {
          if (prevPlayer[statKey] !== player[statKey]) {
            // Log the stat change
            const logEntry = {
              timestamp: new Date().toISOString(),
              actionType: "stat_change",
              details: {
                playerId: player.player_id,
                playerName: player.player_name,
                stat: statKey,
                previousValue: prevPlayer[statKey],
                newValue: player[statKey],
                increment: player[statKey] - prevPlayer[statKey],
              },
            };
            setActionLog((prevLog) => [...prevLog, logEntry]);
          }
        });
      }
    });

    // Update the ref with current playerStats
    prevPlayerStatsRef.current = currentPlayerStats;

    // Call updateCurrentMatch to upload changes to the cloud
    updateCurrentMatch(
      teamScores,
      playerStats,
      myTeam,
      opposition,
      homeAway,
      matchId,
      matchFolderName,
      new Date().toISOString(),
      "ongoing",
      formation,
      formationCoordinates,
      formationPositions,
      markerColor,
      gkColor,
      matchLength,
      numberOfParts,
      matchType,
      selectedFormation,
      positionAssignments
    );
  }, [playerStats]);

  devLog("PressToTalk props received:", {
    matchFolderName,
    myTeam,
    opposition,
    players,
    userId,
    selectedTeamId,
    matchId,
    matchDate,
    status,
    otherInfo,
    homeAway,
    initialTeamScores, // Log initialTeamScores to verify receipt
    formationPositions,
    positionAssignments,
    formationCoordinates,
    markerColor,
    formation,
    gkColor,
    playerSelections,
    matchLength,
    numberOfParts,
    matchType,
    selectedFormation,
  });

  // State Hooks
  const [recording, setRecording] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [showStats, setShowStats] = useState(false); // State for switching between pages
  const [hasUnfinishedMatch, setHasUnfinishedMatch] = useState(true); // Set to true initially as match is not finished
  const [timer, setTimer] = useState(15); // Countdown timer starting at 10 seconds
  const countdownRef = useRef(null); // Ref to store countdown interval
  const [showMenuWarning, setShowMenuWarning] = useState(false); // Show warning when trying to open the menu during a match
  const [time, setTime] = useState(0); // Start time at 0, or set to initial value if available
  // const [isStopwatchRunning, setIsStopwatchRunning] = useState(false); // Start with false by default
  const [showFinishGameModal, setShowFinishGameModal] = useState(false);
  const [teamScores, setTeamScores] = useState({
    myTeamScore: initialTeamScores?.myTeamScore ?? 0,
    oppositionScore: initialTeamScores?.oppositionScore ?? 0,
  });
  //const [accessedViaNavigation, setAccessedViaNavigation] = useState(true); // Initialize with true

  useEffect(() => {
    if (
      initialTeamScores &&
      initialTeamScores.myTeamScore !== undefined &&
      initialTeamScores.oppositionScore !== undefined
    ) {
      // Set team scores from initialTeamScores if continuing an existing game
      setTeamScores(initialTeamScores);
    } else {
      // Set default scores (0-0) if it's a new game
      setTeamScores({
        myTeamScore: 0,
        oppositionScore: 0,
      });
    }
  }, [initialTeamScores]);

  // Refs
  const mediaRecorderRef = useRef(null);
  const chunks = useRef([]);
  const analyserRef = useRef(null);
  const startTimeRef = useRef(null);
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  // const stopwatchRef = useRef(null);
  // const lastSystemTime = useRef(null);
  const stopwatchContainerRef = useRef(null);

  const hasCheckedMatchStarted = useRef(false); // Flag to track if check has been done

  useEffect(() => {
    if (!hasCheckedMatchStarted.current) {
      checkMatchStarted();
      hasCheckedMatchStarted.current = true;
    }
  }, []);

  const checkMatchStarted = async () => {
    try {
      const payload = {
        operationType: "check_match_started",
        data: {
          coach_id: userId,
          team_id: selectedTeamId,
        },
      };

      const response = await axios.post(API_URL, payload);
      if (response.status === 200) {
        const responseData = response.data;

        // Parse the body string to get the actual data
        let isMatchStarted = false;
        if (responseData.match_started !== undefined) {
          // If match_started is directly in responseData
          isMatchStarted = responseData.match_started;
        } else if (responseData.body) {
          // Parse responseData.body if it's a string
          const parsedBody = JSON.parse(responseData.body);
          isMatchStarted = parsedBody.match_started;
        }

        if (isMatchStarted) {
          devLog("Match has already started.");
          setMatchStarted(true); // Update state to true
          // Proceed as normal (no modal)
        } else {
          devLog("Match has not started yet.");
          setShowStartMatchModal(true); // Show the modal
          setMatchStarted(false); // Ensure state is false
        }
      } else {
        console.error(
          "Failed to check match started status:",
          response.statusText
        );
        setShowStartMatchModal(true); // Show the modal
        setMatchStarted(false); // Ensure state is false
      }
    } catch (error) {
      console.error("Error checking match started status:", error);
      setShowStartMatchModal(true); // Show the modal
      setMatchStarted(false); // Ensure state is false
    }
  };

  function shallowCompare(objA, objB) {
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      if (objA[key] !== objB[key]) return false;
    }
    return true;
  }
  const handleStartMatch = async () => {
    const timestamp = new Date().toISOString();
    setRecordingsCount(0);
    localStorage.setItem("recordingsCount", 0);
    try {
      const payload = {
        operationType: "set_match_started",
        data: {
          coach_id: userId,
          team_id: selectedTeamId,
          match_id: matchId,
          timestamp: timestamp,
        },
      };

      const response = await axios.post(API_URL, payload);
      if (response.status === 200) {
        devLog("Match started flag set successfully!");
        // Log the action
        logAction("match_started", { timestamp });
        setShowStartMatchModal(false); // Close the modal
      } else {
        console.error("Failed to set match started flag:", response.statusText);
      }
    } catch (error) {
      console.error("Error setting match started flag:", error);
    }
  };

  const StartMatchModal = ({ onStartMatch, onTeamManagement }) => {
    return (
      <div className="start-match-modal-overlay">
        <div className="start-match-modal-content">
          {/* Progress Bar */}
          <div className="progress-container">
            <div className="progress-bar">
              {/* Step 1 */}
              <div className={`progress-step ${true ? "active" : ""}`}>
                <div className="circle">&#10003;</div>
                <span className="label">Match Setup</span>
              </div>

              {/* Line */}
              <div className="progress-line"></div>

              {/* Step 2 */}
              <div className={`progress-step ${true ? "active" : ""}`}>
                <div className="circle">&#10003;</div>
                <span className="label">Team Selection</span>
              </div>

              {/* Line */}
              <div className="progress-line"></div>

              {/* Step 3 */}
              <div className={`progress-step ${true ? "active" : ""}`}>
                <div className="circle">3</div>
                <span className="label">Start Game</span>
              </div>
            </div>
          </div>

          <h2>The match hasn't started yet.</h2>
          <p>Would you like to start the match or manage your team?</p>
          <div className="modal-buttons">
            <TeamManagementModal
              formation={formation}
              formationCoordinates={formationCoordinates}
              formationPositions={formationPositions}
              positionAssignments={positionAssignments} // Pass positionAssignments
              onUpdateFormation={(updatedData) => {
                setFormation(updatedData.formation);
                setFormationCoordinates(updatedData.formationCoordinates);
                setFormationPositions(updatedData.formationPositions);
                setPositionAssignments(updatedData.positionAssignments); // Update positionAssignments
              }}
              // playerSelections={playerSelections}
              // setPlayerSelections={setPlayerSelections}
              playerStats={playerStats} // Default to an empty array
              setPlayerStats={setPlayerStats}
              markerColor={markerColor}
              gkColor={gkColor}
              matchType={matchType}
            />
            <button onClick={onStartMatch} className="start-match-modal-button">
              Start Match
            </button>
            <button
              className="discard-match-modal-button"
              onClick={promptDiscardMatch}
            >
              <FontAwesomeIcon icon={faTrash} /> Discard Match
            </button>
            {/* Reusing your existing Team Management button */}
          </div>
        </div>
      </div>
    );
  };

  const FinishGameModal = ({ onConfirm, onCancel }) => {
    const [additionalNotes, setAdditionalNotes] = useState(""); // State to capture additional notes

    const handleSaveNotes = async () => {
      if (additionalNotes.trim()) {
        const sanitizedFolderName = sanitizeFolderName(matchFolderName); // Ensure folder name is valid
        const fileName = `${sanitizedFolderName}/additional-notes.json`; // Define the S3 file name

        const notesData = {
          notes: additionalNotes, // Include the additional notes
          matchId: matchId || "unknownMatch", // Include matchId for context
          timestamp: new Date().toISOString(), // Include a timestamp
        };

        const url = `https://${config.BucketName}.s3.${config.region}.amazonaws.com/${fileName}`;

        try {
          const response = await fetch(url, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(notesData),
          });

          if (response.ok) {
            devLog("Additional notes saved successfully to S3!");
          } else {
            console.error(
              "Error saving additional notes to S3:",
              response.statusText
            );
          }
        } catch (error) {
          console.error("Error saving additional notes to S3:", error);
        }
      }
    };

    const handleConfirm = async () => {
      await handleSaveNotes(); // Save notes before confirming
      onConfirm(); // Call the parent's onConfirm function
    };

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>Are you sure you want to finish the game</h2>
          <p>
            All progress will be saved, and the game will be marked as finished.
          </p>
          <textarea
            placeholder="Add any other details you'd like, like MVP or key notes, otherwise leave empty."
            value={additionalNotes}
            onChange={(e) => setAdditionalNotes(e.target.value)}
            className="additional-notes-textarea"
          ></textarea>
          <div className="finish-modal-buttons">
            <button onClick={handleConfirm} className="finish-modal-button">
              Yes, Finish Game
            </button>
            <button onClick={onCancel} className="finish-modal-button">
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const promptDiscardMatch = () => setShowDiscardModal(true);

  const handleConfirmDiscardMatch = async () => {
    try {
      const response = await axios.post(`${API_URL}`, {
        operationType: "clear_current_match",
        data: {
          coach_id: userId,
          team_id: selectedTeamId,
        },
      });

      if (response.status === 200) {
        devLog("Match discarded successfully.");
        setRecordingsCount(0); // Reset state
        localStorage.removeItem("recordingsCount"); // Remove from localStorage
        navigate("/");
      } else {
        console.error("Failed to discard match:", response.statusText);
      }
    } catch (error) {
      console.error("Error discarding match:", error);
    }

    try {
      const clearMatchStartedPayload = {
        operationType: "clear_match_started",
        data: {
          coach_id: userId,
          team_id: selectedTeamId,
        },
      };

      devLog(
        "Payload for clearing match_started flag:",
        clearMatchStartedPayload
      );
      const clearMatchStartedResponse = await axios.post(
        `${API_URL}`,
        clearMatchStartedPayload
      );

      if (clearMatchStartedResponse.status === 200) {
        devLog("Match started flag cleared successfully in DynamoDB.");
      } else {
        console.error(
          "Failed to clear match_started flag in DynamoDB:",
          clearMatchStartedResponse.statusText
        );
        devLog("Full response object:", clearMatchStartedResponse);
      }
    } catch (error) {
      console.error("Error clearing match_started flag in DynamoDB:", error);
    }
  };

  const handleCancelDiscard = () => setShowDiscardModal(false);
  const handleConfirmFinishGame = async () => {
    setShowFinishGameModal(false); // Hide modal
    await uploadPlayerStats(); // Call the original function to upload stats
  };

  const handleCancelFinishGame = () => {
    setShowFinishGameModal(false); // Simply close the modal
  };

  const promptFinishGame = () => {
    setShowFinishGameModal(true);
  };

  const handleUpdateMatchData = (updatedMatchData) => {
    devLog("Updated match data from modal:", updatedMatchData);

    // Update the relevant state in PressToTalk
    setPlayerSelections(updatedMatchData.playerSelections);
    setFormation(updatedMatchData.formation);
    setFormationCoordinates(updatedMatchData.formationCoordinates);
    setFormationPositions(updatedMatchData.formationPositions);
    // Handle other fields as necessary

    // Optionally, trigger `updateCurrentMatch` to save changes to the database
    updateCurrentMatch(updatedMatchData);
  };

  // Handle Menu Button Click
  const handleMenuClick = () => {
    if (hasUnfinishedMatch) {
      setShowMenuWarning(true); // Show warning if a match is ongoing
    } else {
      // Menu logic here if the match is finished
    }
  };
  const prevDataRef = useRef({}); // holds last known "init" data

  useEffect(() => {
    const initializeMatch = async () => {
      devLog("Initializing match with data:");
      devLog({
        myTeam,
        opposition,
        homeAway,
        matchId,
        matchFolderName,
        matchDate,
        teamScores,
        playerSelections,
        playerStats,
        otherInfo,
        formation,
        formationCoordinates,
        formationPositions,
        markerColor,
        gkColor,
        matchLength,
        numberOfParts,
        matchType,
        selectedFormation,
        positionAssignments,
      });

      // 1) Build the current data object
      const currentInitData = {
        myTeam,
        opposition,
        homeAway,
        matchId,
        matchFolderName,
        matchDate,
        // Convert teamScores or playerSelections to JSON if you want stable compare
        teamScores: JSON.stringify(teamScores),
        playerSelectionsLength: playerSelections?.length,
      };

      // 2) Compare to previous snapshot
      const dataHasChanged = !shallowCompare(
        prevDataRef.current,
        currentInitData
      );

      if (dataHasChanged) {
        // Update snapshot so next render can compare
        prevDataRef.current = currentInitData;

        // 3) Check if all data is present
        if (
          myTeam &&
          opposition &&
          homeAway &&
          matchId &&
          matchFolderName &&
          matchDate &&
          teamScores &&
          playerSelections?.length > 0
        ) {
          devLog("All data is present. Calling updateCurrentMatch...");
          await updateCurrentMatch(
            teamScores,
            playerStats,
            myTeam,
            opposition,
            homeAway,
            matchId,
            matchFolderName,
            matchDate,
            otherInfo,
            formation,
            formationCoordinates,
            formationPositions,
            markerColor,
            gkColor,
            matchLength,
            numberOfParts,
            matchType,
            selectedFormation,
            positionAssignments
          );
        } else {
          devLog("Incomplete data, not calling updateCurrentMatch.");
        }
      } else {
        // Data did NOT change, so do nothing
        devLog("initializeMatch: data unchanged, skipping update");
      }
    };

    initializeMatch();
  }, [
    myTeam,
    opposition,
    homeAway,
    matchId,
    matchFolderName,
    matchDate,
    teamScores,
    playerSelections,
    // other dependencies if needed
  ]);

  const updateScore = (team, increment) => {
    if (team === "myTeamScore") {
      // Update extraGoals manually.
      // Ensure extraGoals never goes below zero.
      setExtraGoals((prevExtra) => {
        const newExtra = Math.max(prevExtra + increment, 0);
        const newTeamScore = calculateTotalPlayerGoals() + newExtra;

        // Log the action for record keeping
        logAction("update_score", {
          team: myTeam,
          newScore: newTeamScore,
          increment,
        });

        // Update current match with the new score.
        // (Assuming updateCurrentMatch takes teamScores as one of its parameters.)
        const updatedScores = { ...teamScores, myTeamScore: newTeamScore };
        updateCurrentMatch(
          updatedScores,
          playerSelections,
          myTeam,
          opposition,
          homeAway,
          matchId,
          matchFolderName,
          new Date().toISOString(),
          "ongoing",
          formation,
          formationCoordinates,
          formationPositions,
          markerColor,
          gkColor,
          matchLength,
          numberOfParts,
          matchType,
          selectedFormation,
          positionAssignments
        );

        return newExtra;
      });
    } else {
      // For the opposition team, you can leave your existing update logic.
      setTeamScores((prevScores) => {
        const newScore = prevScores.oppositionScore + increment;
        const updatedScores = { ...prevScores, oppositionScore: newScore };
        logAction("update_score", {
          team: opposition,
          newScore,
          increment,
        });
        updateCurrentMatch(
          updatedScores,
          playerSelections,
          myTeam,
          opposition,
          homeAway,
          matchId,
          matchFolderName,
          new Date().toISOString(),
          "ongoing",
          formation,
          formationCoordinates,
          formationPositions,
          markerColor,
          gkColor,
          matchLength,
          numberOfParts,
          matchType,
          selectedFormation,
          positionAssignments
        );
        return updatedScores;
      });
    }
  };

  const handleTeamManagementUpdate = (updatedData) => {
    // For example, updatedData might contain updated player stats or other info
    setPlayerStats(updatedData.playerStats);

    // Update current match in database if necessary
    updateCurrentMatch(
      teamScores,
      updatedData.playerStats
      // Pass other necessary data
    );
  };

  const updatePlayerStat = (playerIdentifier, stat, increment) => {
    setPlayerStats((prevStats) => {
      const updatedStats = [...prevStats];
      let player;

      // Check if the identifier is a number (playerIndex) or a string (playerId)
      if (typeof playerIdentifier === "number") {
        // Case 1: playerIdentifier is playerIndex
        const playerIndex = playerIdentifier;
        updatedStats[playerIndex][stat] += increment;

        // Ensure the stat doesn't go below zero
        if (updatedStats[playerIndex][stat] < 0) {
          updatedStats[playerIndex][stat] = 0;
        }
      } else {
        // Case 2: playerIdentifier is playerId
        const playerId = playerIdentifier;
        const player = updatedStats.find((p) => p.player_id === playerId);
        if (player) {
          player[stat] = Math.max(player[stat] + increment, 0); // Ensure no negative values
          logAction("update_player_stat", {
            playerId: player.player_id,
            playerName: player.player_name,
            stat,
            newValue: player[stat],
            increment,
          });
        }
      }

      // Call updateCurrentMatch with the updated stats
      updateCurrentMatch(
        teamScores,
        updatedStats,
        myTeam,
        opposition,
        homeAway,
        matchId,
        matchFolderName,
        new Date().toISOString(),
        "ongoing",
        formation,
        formationCoordinates,
        formationPositions,
        markerColor,
        gkColor,
        matchLength,
        numberOfParts,
        matchType,
        selectedFormation,
        positionAssignments
      );

      return updatedStats;
    });
  };

  // Close warning bubble after a timeout
  useEffect(() => {
    if (showMenuWarning) {
      const timeout = setTimeout(() => {
        setShowMenuWarning(false); // Hide warning after 3 seconds
      }, 3000);
      return () => clearTimeout(timeout); // Clean up timeout on unmount
    }
  }, [showMenuWarning]);

  // useEffect to load initial data and start stopwatch if it was running
  // useEffect(() => {
  //   if (isStopwatchRunning) {
  //     startStopwatch();
  //   }
  // }, []); // Only run on component mount

  // Warn on browser close or refresh
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasUnfinishedMatch) {
        event.preventDefault();
        event.returnValue = ""; // Required for most browsers to show a warning message
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnfinishedMatch]);

  // Warn on internal route change
  useEffect(() => {
    const handleNavigationAttempt = (e) => {
      if (hasUnfinishedMatch) {
        const confirmationMessage =
          "You have an unfinished match. Are you sure you want to leave?";
        if (!window.confirm(confirmationMessage)) {
          e.preventDefault();
          return;
        }
        // Mark match as finished if user decides to leave
        setHasUnfinishedMatch(false);
      }
    };

    window.addEventListener("beforeunload", handleNavigationAttempt);
    return () => {
      window.removeEventListener("beforeunload", handleNavigationAttempt);
    };
  }, [hasUnfinishedMatch]);

  useEffect(() => {
    if (stopwatchContainerRef.current) {
      // First scroll into view
      stopwatchContainerRef.current.scrollIntoView({ behavior: "smooth" });

      // Then adjust the scroll position slightly after scrolling into view
      window.scrollBy(0, -5); // Scroll 5px above the element
    }
  }, []); // Empty dependency array ensures it runs only on component mount

  // Function to handle finishing the match
  const finishMatch = () => {
    setHasUnfinishedMatch(false); // Mark match as finished
    // Add logic to reset any necessary state
  };

  // useEffect to save data to local storage whenever states change
  useEffect(() => {
    localStorage.setItem("myTeam", myTeam);
    localStorage.setItem("opposition", opposition);
    localStorage.setItem("time", time);
    // localStorage.setItem(
    //   "isStopwatchRunning",
    //   JSON.stringify(isStopwatchRunning)
    // );
    localStorage.setItem("teamScores", JSON.stringify(teamScores));
    localStorage.setItem("playerSelections", JSON.stringify(playerSelections));
  }, [
    myTeam,
    opposition,
    time,
    // isStopwatchRunning,
    teamScores,
    playerSelections,
  ]);

  // // Function to start the stopwatch
  // const startStopwatch = () => {
  //   if (!isStopwatchRunning) {
  //     const currentSystemTime = Date.now();
  //     lastSystemTime.current = currentSystemTime;
  //     setIsStopwatchRunning(true);

  //     stopwatchRef.current = setInterval(() => {
  //       const now = Date.now();
  //       const elapsedTime = now - lastSystemTime.current;
  //       setTime((prevTime) => prevTime + elapsedTime);
  //       lastSystemTime.current = now;
  //     }, 100);
  //   }
  // };

  // // Function to stop the stopwatch
  // const stopStopwatch = () => {
  //   if (isStopwatchRunning) {
  //     clearInterval(stopwatchRef.current);
  //     setIsStopwatchRunning(false);
  //   }
  // };

  // // Function to reset the stopwatch
  // const resetStopwatch = () => {
  //   clearInterval(stopwatchRef.current);
  //   setTime(0);
  //   setIsStopwatchRunning(false);
  // };

  // // Function to format time for display
  // const formatTime = (time) => {
  //   const totalSeconds = Math.floor(time / 1000);
  //   const getSeconds = `0${totalSeconds % 60}`.slice(-2);
  //   const getMinutes = `0${Math.floor(totalSeconds / 60)}`.slice(-2);
  //   return `${getMinutes}:${getSeconds}`;
  // };

  // Function to start recording audio
  const startRecording = async () => {
    if (recordingsCount >= maxRecordings) {
      alert(
        `You have reached the maximum number of recordings (${maxRecordings}) allowed for your plan.`
      );
      return; // Prevent further recordings
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      // Call startVisualizer here with the stream
      startVisualizer(stream);

      let mimeType;
      if (MediaRecorder.isTypeSupported("audio/webm")) {
        mimeType = "audio/webm"; // Chrome, Firefox
      } else if (MediaRecorder.isTypeSupported("audio/mp4")) {
        mimeType = "audio/mp4"; // Safari
      } else if (MediaRecorder.isTypeSupported("audio/aac")) {
        mimeType = "audio/aac"; // Safari (alternative)
      } else {
        throw new Error("No supported audio format available for recording.");
      }

      const recorder = new MediaRecorder(stream, { mimeType });
      recorder.ondataavailable = (e) => {
        chunks.current.push(e.data);
      };

      recorder.onstop = () => {
        const blob = new Blob(chunks.current, { type: mimeType });
        chunks.current = [];
        const duration = (Date.now() - startTimeRef.current) / 1000;
        if (duration > 0.6) {
          uploadToS3(blob); // Only upload if duration is greater than 0.6 seconds
        } else {
          devLog("Recording too short, not uploading.");
        }
      };

      startTimeRef.current = Date.now();
      recorder.start();
      mediaRecorderRef.current = recorder;
      setRecording(true);

      setRecordingsCount((prev) => prev + 1);

      // Start 15-second countdown
      setTimer(15);
      countdownRef.current = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 1) {
            return prevTimer - 1;
          } else {
            stopRecording(); // Stop the recording when timer hits 0
            return 0;
          }
        });
      }, 1000); // Decrease the timer every second
      logAction("start_recording", {});
    } catch (error) {
      console.error("Error starting recording:", error);
      alert("Unable to start recording. Microphone access or format issue.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      stopVisualizer(); // Stop the visualizer
      setRecording(false);
      clearInterval(countdownRef.current); // Stop the countdown
      logAction("stop_recording", {});
    }
  };

  // Upload function to send audio directly to S3

  const uploadToS3 = async (blob) => {
    setProcessing(true);
    const sanitizedFolderName = sanitizeFolderName(matchFolderName);
    const fileName = `${sanitizedFolderName}/webm/audio-${Date.now()}.webm`;

    const url = `https://${config.BucketName}.s3.${config.region}.amazonaws.com/${fileName}`;
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "audio/webm",
        },
        body: blob,
      });

      if (response.ok) {
        devLog("Uploaded successfully to S3!");
      } else {
        console.error("Error uploading to S3:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading to S3:", error);
    }

    setProcessing(false);
  };

  // Function to upload player stats to S3 and navigate to home page
  const uploadPlayerStats = async () => {
    if (recording) {
      devLog(
        "Recording is still in progress. Stopping recording before uploading."
      );
      try {
        await stopRecording();
        devLog("Audio upload complete. Proceeding with stats upload.");
      } catch (error) {
        console.error("Error stopping recording or uploading audio:", error);
        return;
      }
    }

    const fileName = `${matchFolderName}/${Date.now()}-player-stats.json`;
    const statsData = {
      myTeam,
      opposition,
      teamScores: {
        myTeamScore: teamScores.myTeamScore,
        oppositionScore: teamScores.oppositionScore,
      },
      playerStats,
      actionLog,
    };

    const url = `https://${config.BucketName}.s3.${config.region}.amazonaws.com/${fileName}`;

    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(statsData),
      });

      if (response.ok) {
        devLog("Player stats uploaded successfully to S3!");
        const cleanedMatchId = matchId
          ? matchId.replace(/^match-/, "")
          : "defaultMatchId"; // Use a default if matchId is undefined
        const saveMatchPayload = {
          operationType: "save_match_to_db",
          data: {
            team_id: selectedTeamId,
            matchId: cleanedMatchId,
            match_data: {
              myTeam,
              opposition,
              homeAway,
              match_date: new Date().toISOString(),
              match_folder: matchFolderName,
              teamScores: {
                myTeamScore: teamScores.myTeamScore,
                oppositionScore: teamScores.oppositionScore,
              },
              playerStats,
            },
          },
        };

        try {
          const clearMatchStartedPayload = {
            operationType: "clear_match_started",
            data: {
              coach_id: userId,
              team_id: selectedTeamId,
            },
          };

          devLog(
            "Payload for clearing match_started flag:",
            clearMatchStartedPayload
          );
          const clearMatchStartedResponse = await axios.post(
            `${API_URL}`,
            clearMatchStartedPayload
          );

          if (clearMatchStartedResponse.status === 200) {
            devLog("Match started flag cleared successfully in DynamoDB.");
          } else {
            console.error(
              "Failed to clear match_started flag in DynamoDB:",
              clearMatchStartedResponse.statusText
            );
            devLog("Full response object:", clearMatchStartedResponse);
          }
        } catch (error) {
          console.error(
            "Error clearing match_started flag in DynamoDB:",
            error
          );
        }

        try {
          const saveMatchResponse = await axios.post(
            `${API_URL}`,
            saveMatchPayload
          );
          // Log request and response details
          devLog("Payload sent to save_match_to_db Lambda:", saveMatchPayload);
          devLog("Response from DynamoDB Lambda:", saveMatchResponse);
          if (saveMatchResponse.status === 200) {
            devLog("Match saved successfully to DynamoDB.");
          } else {
            console.error(
              "Failed to save match to DynamoDB:",
              saveMatchResponse.statusText
            );
          }
        } catch (error) {
          console.error("Error saving match to DynamoDB:", error);
        }
        // Clear the current match in DynamoDB
        try {
          const apiPayload = {
            operationType: "clear_current_match",
            data: {
              coach_id: userId, // Replace `userId` with the actual coach ID
              team_id: selectedTeamId, // Replace `selectedTeamId` with the actual team ID
            },
          };

          devLog("API Payload for clearing current match:", apiPayload);
          const clearResponse = await axios.post(`${API_URL}`, apiPayload);

          if (clearResponse.status === 200) {
            devLog("Current match cleared successfully in DynamoDB.");
          } else {
            console.error(
              "Failed to clear current match in DynamoDB:",
              clearResponse.statusText
            );
            devLog("Full response object:", clearResponse);
          }
        } catch (apiError) {
          console.error("Error clearing current match in DynamoDB:", apiError);
        }
        // Decrease games left for the coach
        try {
          const decreaseGamesPayload = {
            operationType: "decrease_games_left",
            data: {
              coach_id: userId, // Replace `userId` with the actual coach ID
            },
          };

          devLog("Payload for decreasing games left:", decreaseGamesPayload);
          const decreaseResponse = await axios.post(
            `${API_URL}`,
            decreaseGamesPayload
          );

          if (decreaseResponse.status === 200) {
            devLog("Games left decreased successfully:", decreaseResponse.data);
          } else {
            console.error(
              "Failed to decrease games left:",
              decreaseResponse.statusText
            );
            devLog("Full response object:", decreaseResponse);
          }
        } catch (error) {
          console.error("Error decreasing games left:", error);
        }

        finishGame(); // Finish game and reset states
      } else {
        console.error(
          "Error uploading player stats to S3:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error uploading player stats:", error);
    }
  };

  // Function to finish the game, clear localStorage, and reset all states
  const [showGameSavedModal, setShowGameSavedModal] = useState(false);

  const finishGame = () => {
    // Clear local storage for match-related values
    localStorage.removeItem("matchFolderName");
    localStorage.removeItem("myTeam");
    localStorage.removeItem("opposition");
    localStorage.removeItem("time");
    // localStorage.removeItem("isStopwatchRunning");
    localStorage.removeItem("teamScores");
    localStorage.removeItem("playerSelections");

    // Reset state values
    setRecordingsCount(0);
    setTime(0);
    // setIsStopwatchRunning(false);
    setTeamScores({ myTeamScore: 0, oppositionScore: 0 });
    setPlayerStats(
      players.map((player) => ({
        name: player,
        goals: 0,
        assists: 0,
        shotsOnTarget: 0,
        shotsOffTarget: 0,
        defensive_actions: 0,
        saves: 0,
      }))
    );

    // Show the confirmation modal
    setShowGameSavedModal(true);

    // Call API to clear current match from DynamoDB just before navigating
    setTimeout(async () => {
      try {
        const apiPayload = {
          operationType: "clear_current_match",
          data: {
            coach_id: userId, // Replace `userId` with actual coach ID
            team_id: selectedTeamId, // Replace `selectedTeamId` with actual team ID
          },
        };

        devLog("API Payload for clearing current match:", apiPayload);
        const clearResponse = await axios.post(`${API_URL}`, apiPayload);

        if (clearResponse.status === 200) {
          devLog("Current match cleared successfully in DynamoDB.");
        } else {
          console.error(
            "Failed to clear current match in DynamoDB:",
            clearResponse.statusText
          );
          devLog("Full response object:", clearResponse);
        }
      } catch (apiError) {
        console.error("Error clearing current match in DynamoDB:", apiError);
      }

      // Navigate to home page after clearing match in DynamoDB
      navigate("/");
    }, 3000); // Wait 3 seconds before executing the API call and navigating
  };

  // Game Saved Modal Component
  const GameSavedModal = ({ onClose }) => {
    const handleImmediateNavigation = async () => {
      try {
        const apiPayload = {
          operationType: "clear_current_match",
          data: {
            coach_id: userId, // Replace with actual coach ID
            team_id: selectedTeamId, // Replace with actual team ID
          },
        };

        devLog("API Payload for clearing current match:", apiPayload);
        const clearResponse = await axios.post(`${API_URL}`, apiPayload);

        if (clearResponse.status === 200) {
          devLog("Current match cleared successfully in DynamoDB.");
        } else {
          console.error(
            "Failed to clear current match in DynamoDB:",
            clearResponse.statusText
          );
          devLog("Full response object:", clearResponse);
        }
      } catch (apiError) {
        console.error("Error clearing current match in DynamoDB:", apiError);
      }

      // Navigate immediately
      onClose();
    };

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0, 0, 0, 0.8)", // Dark semi-transparent background
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999, // Ensure it appears above everything
        }}
      >
        <div
          style={{
            background: "white",
            padding: "20px",
            borderRadius: "10px",
            textAlign: "center",
            width: "90%",
            maxWidth: "400px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          }}
        >
          <h2>Game Saved Successfully!</h2>
          <p>Your match has been saved. You will be redirected shortly.</p>
          <button
            onClick={handleImmediateNavigation}
            style={{
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              padding: "10px 15px",
              fontSize: "16px",
              cursor: "pointer",
              marginTop: "10px",
              borderRadius: "5px",
              transition: "background 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#0056b3")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#007bff")}
          >
            Go to Home Now
          </button>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (myTeam) {
      localStorage.setItem("myTeam", myTeam);
    }
  }, [myTeam]);

  useEffect(() => {
    if (opposition) {
      localStorage.setItem("opposition", opposition);
    }
  }, [opposition]);
  const sanitizeFolderName = (folderName) => {
    return folderName.replace(/[^a-zA-Z0-9-_/.!*'()]/g, "_");
  };

  // Set up audio context and analyser for visualizer
  const startVisualizer = (stream) => {
    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const analyser = audioContext.createAnalyser();
    const source = audioContext.createMediaStreamSource(stream);

    analyser.fftSize = 2048;
    const bufferLength = analyser.frequencyBinCount;
    const dataArray = new Uint8Array(bufferLength);

    source.connect(analyser);
    audioContextRef.current = audioContext;
    analyserRef.current = analyser;

    const canvasCtx = canvasRef.current.getContext("2d");

    const draw = () => {
      if (!analyserRef.current) return;

      analyser.getByteTimeDomainData(dataArray);

      canvasCtx.fillStyle = "rgb(200, 200, 200)";
      canvasCtx.fillRect(
        0,
        0,
        canvasRef.current.width,
        canvasRef.current.height
      );

      canvasCtx.lineWidth = 2;
      canvasCtx.strokeStyle = "rgb(0, 0, 0)";
      canvasCtx.beginPath();

      const sliceWidth = (canvasRef.current.width * 1.0) / bufferLength;
      let x = 0;

      for (let i = 0; i < bufferLength; i++) {
        const v = dataArray[i] / 128.0;
        const y = (v * canvasRef.current.height) / 2;

        if (i === 0) {
          canvasCtx.moveTo(x, y);
        } else {
          canvasCtx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      canvasCtx.lineTo(canvasRef.current.width, canvasRef.current.height / 2);
      canvasCtx.stroke();

      requestAnimationFrame(draw);
    };

    draw();
  };

  const stopVisualizer = () => {
    if (audioContextRef.current) {
      audioContextRef.current.close();
      audioContextRef.current = null;
      analyserRef.current = null;
    }
  };
  const handleTeamManagement = () => {
    setShowStartMatchModal(false);
    setIsTeamManagementVisible(true);
  };

  const handleTeamManagementClose = () => {
    setIsTeamManagementVisible(false);
    setShowStartMatchModal(true); // Optionally re-open the Start Match modal
  };

  const updateCurrentMatch = async (
    updatedScores,
    updatedPlayerStats,
    myTeam,
    opposition,
    homeAway,
    matchId,
    matchFolder,
    matchDate,
    otherInfo,
    formation,
    formationCoordinates,
    formationPositions,
    markerColor,
    gkColor,
    matchLength,
    numberOfParts,
    matchType,
    selectedFormation,
    positionAssignments
  ) => {
    const teamIdWithoutPrefix = selectedTeamId.replace(/^TEAM#/, "");

    devLog("updateCurrentMatch called with values:");
    devLog("updatedScores:", updatedScores);
    devLog("updatedPlayerStats:", updatedPlayerStats);
    devLog("myTeam:", myTeam);
    devLog("opposition:", opposition);
    devLog("homeAway:", homeAway);
    devLog("matchId:", matchId);
    devLog("matchFolder:", matchFolder);
    devLog("matchDate:", matchDate);
    devLog("otherInfo:", otherInfo);
    devLog("formation:", formation);
    devLog("formationCoordinates:", formationCoordinates);
    devLog("formationPositions:", formationPositions);
    devLog("markerColor:", markerColor);
    devLog("gkColor:", gkColor);
    devLog("matchLength:", matchLength);
    devLog("numberOfParts:", numberOfParts);
    devLog("matchType:", matchType);
    devLog("selectedFormation:", selectedFormation);
    devLog("positionAssignments:", positionAssignments);

    const payload = {
      operationType: "update_current_match",
      data: {
        coach_id: userId,
        team_id: teamIdWithoutPrefix,
        current_match: {
          playerSelections: updatedPlayerStats,
          teamScores: updatedScores,
          myTeam,
          opposition,
          homeAway,
          matchId,
          match_folder: matchFolder,
          match_date: matchDate,
          status,
          otherInfo,
          formation,
          formationCoordinates,
          formationPositions,
          markerColor,
          gkColor,
          matchLength,
          numberOfParts,
          matchType,
          selectedFormation,
          positionAssignments,
        },
      },
    };

    devLog("Payload for updateCurrentMatch:", payload);

    try {
      const response = await axios.post(`${API_URL}`, payload);
      if (response.status === 200) {
        devLog("Current match updated successfully in DynamoDB.");
      } else {
        console.error("Failed to update current match:", response.statusText);
      }
    } catch (error) {
      console.error("Error updating current match:", error);
    }
  };
  devLog("Parent playerStats:", playerStats);

  return (
    // Render components and UI
    <div className="flex flex-col items-center justify-center p-4">
      {/* Discard Match Button */}
      <div className="discard-button-container">
        <button className="discard-button" onClick={promptDiscardMatch}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
      <Navigation hasUnfinishedMatch={hasUnfinishedMatch} />

      {/* Scoreboard */}
      <div className="text-center mb-4" style={{ margin: 0 }}>
        <div className="flex justify-around mt-6 w-full">
          {/* Dynamic team order based on homeAway */}
          {homeAway === "home" ? (
            <>
              {/* My Team (Home) */}
              <div className="flex flex-col items-center w-1/2 border-r border-gray-300 pr-4">
                <h3 className="text-lg sm:text-base font-semibold mb-2 truncate">
                  {myTeam}
                </h3>
                <div className="flex items-center">
                  {/* Only allow '-' if there is an extra goal (so teamScore > base score) */}
                  <button
                    onClick={() => updateScore("myTeamScore", -1)}
                    className="team-score-button mx-2"
                    disabled={extraGoals === 0}
                  >
                    <i className="fas fa-minus"></i>
                  </button>

                  {/* Displayed team score is base + extra */}
                  <span className="mx-4 text-2xl sm:text-xl font-bold">
                    {teamScores.myTeamScore}
                  </span>

                  {/* Always allow '+' (to add an own goal manually) */}
                  <button
                    onClick={() => updateScore("myTeamScore", 1)}
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              {/* Opposition (Away) */}
              <div className="flex flex-col items-center w-1/2 pl-4">
                <h3 className="text-lg sm:text-base font-semibold mb-2 truncate">
                  {opposition}
                </h3>
                <div className="flex items-center">
                  <button
                    onClick={() =>
                      updateScore(
                        "oppositionScore",
                        teamScores.oppositionScore > 0 ? -1 : 0
                      )
                    }
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                  <span className="mx-4 text-2xl sm:text-xl font-bold">
                    {teamScores.oppositionScore}
                  </span>
                  <button
                    onClick={() => updateScore("oppositionScore", 1)}
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Opposition (Home) */}
              <div className="flex flex-col items-center w-1/2 border-r border-gray-300 pr-4">
                <h3 className="text-lg sm:text-base font-semibold mb-2 truncate">
                  {opposition}
                </h3>
                <div className="flex items-center">
                  <button
                    onClick={() =>
                      updateScore(
                        "oppositionScore",
                        teamScores.oppositionScore > 0 ? -1 : 0
                      )
                    }
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                  <span className="mx-4 text-2xl sm:text-xl font-bold">
                    {teamScores.oppositionScore}
                  </span>
                  <button
                    onClick={() => updateScore("oppositionScore", 1)}
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              {/* My Team (Away) */}
              <div className="flex flex-col items-center w-1/2 pl-4">
                <h3 className="text-lg sm:text-base font-semibold mb-2 truncate">
                  {myTeam}
                </h3>
                <div className="flex items-center">
                  <button
                    onClick={() =>
                      updateScore(
                        "myTeamScore",
                        teamScores.myTeamScore > 0 ? -1 : 0
                      )
                    }
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-minus"></i>
                  </button>
                  <span className="mx-4 text-2xl sm:text-xl font-bold">
                    {teamScores.myTeamScore}
                  </span>
                  <button
                    onClick={() => updateScore("myTeamScore", 1)}
                    className="team-score-button mx-2"
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div>
        {/* Conditionally show canvas only for "AI Match Reports Plan" or "Free" */}
        {(currentPlan === "AI Match Reports Plan" ||
          currentPlan === "free") && (
          <canvas ref={canvasRef} className="canvas-visualizer"></canvas>
        )}

        <div className="mt-4 flex flex-col items-center space-y-4">
          {/* Start Recording Button */}
          <button
            onClick={startRecording}
            disabled={
              !["AI Match Reports Plan", "free"].includes(currentPlan) || // Disable if currentPlan is not valid
              recording || // Disable if a recording is already in progress
              processing || // Disable if audio is being processed
              recordingsCount >= maxRecordings // Disable if the user has reached the recording limit
            } // Enable button only for "AI Match Reports Plan" or "Free"
            className={`press-to-talk-button ${recording ? "recording" : ""} ${
              !["AI Match Reports Plan", "free"].includes(currentPlan)
                ? "disabled"
                : ""
            }`} // Add custom styling for disabled state
          >
            {processing ? (
              "Uploading Audio..." // Show upload message if audio is being uploaded
            ) : recording ? (
              <span className="countdown-number">{timer}</span> // Display countdown timer with red color when recording
            ) : !["AI Match Reports Plan", "free"].includes(currentPlan) ? (
              <span style={{ fontSize: "0.9rem" }}>
                Voice recordings only available on AI Match Reports plans
              </span> // Smaller text for other plans
            ) : (
              <>
                {"\uD83C\uDF99"} Start Recording (
                {maxRecordings - recordingsCount} left)
              </>
            )}
          </button>

          {/* Stop Recording Button (visible only when recording and on allowed plans) */}
          {recording &&
            !processing &&
            ["AI Match Reports Plan", "free"].includes(currentPlan) && (
              <button
                onClick={stopRecording}
                className="stop-recording-button mt-4"
              >
                Stop Recording
              </button>
            )}
        </div>
      </div>

      <div className="custom-heading">
        {/* Heading content */}
        Press a player to add stats:
      </div>
      {/* Start Match Modal */}
      {showStartMatchModal && (
        <StartMatchModal
          onStartMatch={handleStartMatch}
          onTeamManagement={handleTeamManagement}
          // coachId={userId}
        />
      )}
      <TeamManagementModal
        formation={formation}
        formationCoordinates={formationCoordinates}
        formationPositions={formationPositions}
        positionAssignments={positionAssignments} // Pass positionAssignments
        onUpdateFormation={(updatedData) => {
          setFormation(updatedData.formation);
          setFormationCoordinates(updatedData.formationCoordinates);
          setFormationPositions(updatedData.formationPositions);
          setPositionAssignments(updatedData.positionAssignments); // Update positionAssignments
        }}
        // playerSelections={playerSelections}
        // setPlayerSelections={setPlayerSelections}
        playerStats={playerStats} // Default to an empty array
        setPlayerStats={setPlayerStats}
        markerColor={markerColor}
        gkColor={gkColor}
        matchType={matchType}
      />
      {/* Button to Upload Player Stats */}
      {/* <div className="mt-4 flex flex-col items-center space-y-4">
        <div className="upload-player-stats-container">
          {!recording && !processing && (
            <button
              onClick={promptFinishGame} // Open the confirmation modal
              className="upload-player-stats-button"
              disabled={recording || processing} // Disable while recording or processing
            >
              {processing ? "Uploading..." : "Finish Match"}
            </button>
          )}
        </div>
      </div> */}
      <div className="mt-4 flex flex-col items-center space-y-4">
        <div className="upload-player-stats-container">
          {!recording && !processing && (
            <div style={{ display: "flex", gap: "10px" }}>
              {/* Finish Match Button */}
              <button
                onClick={promptFinishGame}
                className="upload-player-stats-button"
                disabled={recording || processing}
              >
                {processing ? "Uploading..." : "Finish Match"}
              </button>
              {/* Half Time Report Button */}
              {showHalfTimeReportButton && (
                <button
                  onClick={handleHalfTimeReport}
                  className="upload-player-stats-button"
                  disabled={recording || processing || halfTimeProcessing}
                >
                  {halfTimeProcessing ? "Processing..." : "Half Time Report"}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
      {/* Conditionally render Finish Game modal */}
      {showFinishGameModal && (
        <FinishGameModal
          onConfirm={handleConfirmFinishGame}
          onCancel={handleCancelFinishGame}
        />
      )}
      {/* Conditionally render Discard Match Modal */}
      {showDiscardModal && (
        <div className="discard-modal-overlay" onClick={handleCancelDiscard}>
          <div
            className="discard-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Discard Match</h2>
            <p>Are you sure you want to discard this match?</p>
            <div className="discard-match-modal-buttons">
              <button
                onClick={handleConfirmDiscardMatch}
                className="discard-match-modal-button confirm"
              >
                Yes, Discard
              </button>
              <button
                onClick={handleCancelDiscard}
                className="discard-modal-button-cancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showGameSavedModal && <GameSavedModal onClose={() => navigate("/")} />}
    </div>
  );
};

export default PressToTalk;
